import { DataGridColumns } from '@unicorn-shared/interface/uiKit/DataGrid/DataGrid.types';
import i18n from '@shared/config/i18n';

export type ImportErrorRow = {
  id: string;
  cell: string;
  columnTitle: string;
  value: string;
  error: string;
};

export const columns: DataGridColumns<ImportErrorRow> = [
  {
    field: 'cell',
    headerName: i18n.t('Cell') ?? '',
    width: 80,
    sortable: false,
    hideable: false,
  },
  {
    field: 'columnTitle',
    headerName: i18n.t('ColumnTitle') ?? '',
    width: 180,
    sortable: false,
    hideable: true,
  },
  {
    field: 'value',
    headerName: i18n.t('Value') ?? '',
    width: 350,
    sortable: false,
    hideable: true,
  },
  {
    field: 'error',
    headerName: i18n.t('Error') ?? '',
    width: 350,
    sortable: false,
    hideable: true,
  },
];
